export type WebshopItemForTranslateResponse = {
  productName: string;
  title: string;
  subtitle: string;
  preface: string;
  whatIsTitle: string;
  whatIsParagraphs: {
    text: string;
  }[];
  marketingInfo: {
    title: string;
    text: string;
  }[];
  dosingText: string;
  dosingParagraphs: {
    text: string;
  }[];
  ingredients: {
    name: string;
    subingredients: {
      name: string;
    }[];
  }[];
};


export function getWebshopItemForTranslate(id : string, language: string): string {
  return `
    query WebshopProduct {
      productPage(
        locale:${language},
        filter:{id: {eq: "${id}"}}
      ) {
        productName,
        title,
        subtitle,
        preface,
        whatIsTitle,
        whatIsParagraphs {
          text
        },
        marketingInfo {
          title,
          text,
        },
        dosingText,
        dosingParagraphs {
          text
        },
        ingredients {
          name,
          subingredients {
            name
          }
        }
      }
    }
  `;
}